import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Deliberately a separate api slice from listingServices even though it calls the same
// /admin/listings endpoint. The listings dashboard and a user's listings panel have
// independent lifecycles: this keeps their caches, tags and loading flags apart, so a
// mutation or refetch on one never invalidates or re-renders the other.
export const userListingsApi = createApi({
    reducerPath: 'userListingsApi',
    baseQuery: (fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_BACKEND_HOST}/api`, prepareHeaders: (headers) => {
            const token = localStorage.getItem('prona_userToken');
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })),
    tagTypes: ['User Listings'],
    endpoints: (build) => ({
        getUserListings: build.query({
            query(params) {
                const queryParams = new URLSearchParams(params).toString()
                return {
                    url: `/admin/listings?${queryParams}`,
                    params: {},
                    method: 'GET',
                    headers: {}
                }
            },
            providesTags: ['User Listings']
        }),
    }),
});

export const {
    useGetUserListingsQuery,
    useLazyGetUserListingsQuery
} = userListingsApi;
